var sourceUrl;
var documentWidth = $(document).width();
var RootDataModel = modelInitializer.Get("RootData");

//define date picker mode
var datePickerMode = localStorage.getItem("datePickerMode")
  ? Number(localStorage.getItem("datePickerMode"))
  : 2;

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  $(document).mouseup(function (e) {
    if (
      !$(".js-rooms-options").is(e.target) && // if the target of the click isn't the container...
      $(".js-rooms-options").has(e.target).length === 0
    ) {
      if ($(window).width() > 767) {
        // ... nor a descendant of the container
        $(".js-rooms-options").removeClass(
          "hotel-booking__rooms-options--open"
        );
      }
    }
  });

  hotelDatePicker();
});

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

$(function () {
  //close autoComplete in mobile
  $(".js-hotel-cities").delegate(
    ".js-close-auto-complete",
    "click",
    function () {
      $(".js-close").closest(".focused").removeClass("focused");
      $(".js-mobile-layout").show();
      $("#js-hotel-city").hotelautoComplete("close");
      $("html").removeClass("no-scroll");
      $(".js-search-input").removeClass("show-mobile");
    }
  );
});

var hotelList = [];






//autoComplete
function hotelSearch() {
  $(".js-booking-section").each(function () {
    var $this = $(this);
    if ($(this).hasClass("active")) {
      if ($(this).attr("data-searchType") === "internal-hotel") {
        if (typeof internalHotelList != "undefined") {
          hotelList = internalHotelList;
        }
        $this.find(".js-hotel-form #js-hotel-city").each(function () {
          hotelAutoSearch($(this), 2);
        });
      } else {
        if (typeof externalHotelList != "undefined") {
          hotelList = externalHotelList;
        }

        $this.find(".js-hotel-form #js-hotel-city").each(function () {
          hotelAutoSearch($(this), 1);
        });
      }
    }
  });

  $(".js-tab-nav .js-tab-nav-header button").on("click", function () {
    setTimeout(function () {
      if (
        $(".js-tab-nav").find("li.active").attr("data-searchType") ===
        "internal-hotel"
      ) {
        if (typeof internalHotelList != "undefined") {
          hotelList = internalHotelList;
        }
        $(".js-hotel-form #js-hotel-city").each(function () {
          hotelAutoSearch($(this), 2);
        });
      } else {
        if (typeof externalHotelList != "undefined") {
          hotelList = externalHotelList;
        }

        $(".js-hotel-form #js-hotel-city").each(function () {
          hotelAutoSearch($(this), 1);
        });
      }
    }, 0);
  });

  $(".js-hotel-form #js-hotel-city").each(function () {
    if ($(this).attr("data-searchtype")) {
      if ($(this).attr("data-searchtype") == "internal-hotel") {
        hotelAutoSearch($(this), 2);
      } else if ($(this).attr("data-searchtype") == "external-hotel") {
        hotelAutoSearch($(this), 1);
      }
    }
  });
}

$.widget("custom.hotelautoComplete", $.ui.autocomplete, {
  _renderMenu: function (ul, items) {
    var that = this;
    $.each(items, function (index, item) {
      if (Object.keys(item).length) {
        that._renderItemData(ul, item);
      }
    });
  },
  _renderItem: function (ul, item) {
    var li = "";
    if (Object.keys(item).length) {
      var className = item.destinationType === 2 ? "rtl" : "ltr";

      ul.removeClass("rtl ltr");

      ul.addClass(className);

      var icon = item.locationType === 1 ? "icon-map " : "icon-bed";

      var location;

      if (item.destinationType === 1) {
        location =
          item.locationType === 1
            ? `<span>${item.countryTitle}</span>`
            : `<span>${item.countryTitle + " , " + item.cityTitle}</span>`;
      } else {
        location =
          item.locationType === 2 ? `<span>${item.cityTitle}</span>` : null;
      }
      li +=
        "<li>" +
        '<span class="item-wrapper">' +
        "<i class='" +
        icon +
        "'>" +
        "</i>" +
        item.value +
        "</span>";

      if (location) {
        li += location;
      }

      li += "</li>";
    }

    return $(li).appendTo(ul);
  },
});









// hotel auto search
function hotelAutoSearch($this, $destinationType) {
  $this
    .hotelautoComplete({
      minLength: 0,
      appendTo: $this.next(".js-hotel-search-list"),
      delay: 600,
      search: function () {
        $(this).parent().find(".js-search-loading").show();
        if (documentWidth < 992) {
          $("html").addClass("no-scroll");
        }
        $(this).parent().find(".js-search-loading").hide();
      },
      source: function (request, response) {
        if ($this.val() && hotelList !== null) {
          $this.parent().find(".js-search-loading").show();
          $.ajax({
            url:
              "/hotelbooking-api/searchtitle/" +
              request.term +
              "/?destinationtype=" +
              $destinationType +
              "&demandtype=0",
            dataType: "json",
            success: function (data) {
              //hotel
              $this.parent().find(".js-search-loading").hide();
              response(
                $.map(data.model, function (obj) {
                  return {
                    value: obj.title,
                    hotelTitle: obj.title,
                    slug: obj.slug,
                    cityTitle: obj.cityTitle,
                    citySlug: obj.citySlug,
                    countrySlug: obj.countrySlug,
                    countryTitle: obj.countryTitle,
                    locationType: obj.locationType,
                    destinationType: obj.destinationType,
                    id: obj.id,
                    isRtl: obj.isRtl,
                    dir: obj.dir,
                  };
                })
              );
            },
            error: function () {
              $this.parent().find(".js-search-loading").hide();
            },
          });
        } else {
          $this.parent().find(".js-search-loading").hide();
          return response(hotelList);
        }
      },
      open: function () {
        $this.addClass("focusedInput");
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");

        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $this.attr("autocomplete", "off");
        }

        var inputObj = $(this);
        inputObj
          .next(".js-hotel-search-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });

        // $(".js-search-input").addClass("show-mobile");
      },
      close: function () {
        $this.removeClass("focusedInput");

        if ($("html").hasClass("no-scroll")) {
          $("html").removeClass("no-scroll");
        }
      },
      select: function (e, ui) {
        window.hotelDataModel.hotelTitle = ui.item.value;

        window.hotelDataModel.slug = ui.item.slug;

        window.hotelDataModel.cityTitle = ui.item.cityTitle;

        window.hotelDataModel.citySlug = ui.item.citySlug;

        window.hotelDataModel.countryTitle = ui.item.countryTitle;

        window.hotelDataModel.countrySlug = ui.item.countrySlug;

        window.hotelDataModel.locationType = ui.item.locationType;

        window.hotelDataModel.destinationType = ui.item.destinationType;

        window.hotelDataModel.id = ui.item.id;

        window.hotelDataModel.dir = ui.item.dir;

        /////////////

        $this.removeClass("empty");
        $this.closest(".js-search-input").addClass(ui.item.dir);

        $this.attr("data-value", ui.item.value);

        $this
          .closest(".js-hotel-form")
          .find(".js-hotel-check-in-date")
          .trigger("focus");
        setTimeout(function () {
          document.activeElement.blur();
        }, 0);

        if (documentWidth <= 992) {
          $this.attr("placeholder", ui.item.value);
          $this.trigger("blur");
          $this
            .closest(".js-hotel-form")
            .find(".js-hotel-input-layout")
            .html("<span>" + ui.item.value + "</span>");
          $this.parent().find(".js-search-loading").hide();
        }

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");

        $this.parent().find(".js-search-loading").hide();

        $this
          .siblings(".js-hotel-input-layout")
          .html("<span>" + ui.item.value + "</span>");

        $(this).closest(".js-search-input").removeClass("show-mobile");
        $("html").removeClass("no-scroll");

        tagManager({ value: ui.item.value, type: searchType });
      },
    })
    .bind("focus", function () {
      $this.val("");
      $this.hotelautoComplete("search");
      $this.parent().find(".js-search-loading").hide();
    })
    .bind("blur", function () {
      $this.val($this.attr("placeholder"));
      $this.parent().find(".js-search-loading").hide();
    });
}

$("body").delegate(".js-hotel-input-layout", "click", function () {
  $(this).closest(".js-search-input").addClass("show-mobile");

  $(this).next().trigger("focus");
  $("#js-hotel-city").hotelautoComplete("search");
});












//toggle room detail
$("body").delegate(".js-rooms-toggle", "click", function () {
  $(this).toggleClass("hotel-booking__rooms-options--open");
  if (documentWidth < 992) {
    $("html").addClass("no-scroll");
  }
  checkAlignBox();
});

//room close
$("body").delegate(".js-room-close, .js-rooms-confirm", "click", function () {
  $(".js-rooms-toggle").removeClass("hotel-booking__rooms-options--open");
  if ($("html").hasClass("no-scroll")) {
    $("html").removeClass("no-scroll");
  }
});

//check form validation
function checkValidation() {
  var valid = true;
  $(this).closest(".js-hotel-form").find(".error-message").remove();

  if (
    window.hotelDataModel.hotelTitle === "" ||
    $('.js-booking-section.active input[name="hotel-city"]').val() === "" ||
    window.hotelDataModel.hotelStartDateEn === "" ||
    window.hotelDataModel.hotelEndDateEn === ""
  ) {
    $(this)
      .closest(".js-hotel-form")
      .append(`<span class="error-message">لطفا همه فیلدها را پر کنید</span>`);
    valid = false;
  }

  if (
    window.hotelDataModel.rooms.flatMap((element) => element.childs).includes(0)
  ) {
    $(this)
      .closest(".js-hotel-form")
      .append(
        `<span class="error-message error-message--child">لطفا فیلد سن کودک را پر کنید را پر کنید</span>`
      );
    valid = false;
  }

  var startDate = moment(
    $('.js-booking-section.active input[name="hotelStartDate"]').next().val()
  );

  var endDate = moment(
    $('.js-booking-section.active input[name="hotelEndDate"]').next().val()
  );

  var dateDifference = endDate.diff(startDate, "days");

  if (dateDifference > 20) {
    $(".js-hotel-form .js-hotel-booking-date").append(
      '<span class="error-message">بازه تاریخ ورود و برگشت نباید بیشتر از 20 روز باشد.</span>'
    );

    valid = false;
  }

  return valid;
}

//search event
$("body").delegate(".js-hotel-search", "click", function () {
  var adultsString = "",
    childString = "",
    childAgeString = "";

  $.each(window.hotelDataModel.rooms, function (i, room) {
    adultsString += "&a=" + room.adult;

    childString += "&c=" + room.child;

    $.each(room.childs, function (j, child) {
      childAgeString += "&g=" + Number(child - 1);
    });
  });

  var url = "/fa/hotel/";

  var valid = checkValidation.bind(this)();

  if (!valid) {
    return;
  }

  url +=
    `${window.hotelDataModel.countrySlug
      ? `${window.hotelDataModel.countrySlug}/`
      : ""
    }` +
    `${window.hotelDataModel.citySlug ? `${window.hotelDataModel.citySlug}/` : ""
    }`;
  if (
    window.hotelDataModel.locationType === 2 &&
    window.searchInitialize?.search?.isStaticPage === false
  ) {
    url += window.hotelDataModel.slug ? `${window.hotelDataModel.slug}/` : "";
  }

  let destinationId = window.hotelDataModel.id;

  if (window.searchInitialize?.search?.isStaticPage === true) {
    destinationId = window.searchInitialize.search.destinations.cityId;

    sessionStorage.setItem("staticHotelComesFrom", window.hotelDataModel.id);
  }

  url +=
    "?i=" +
    window.hotelDataModel.hotelStartDateEn +
    "&o=" +
    window.hotelDataModel.hotelEndDateEn +
    "&r=" +
    window.hotelDataModel.roomsCount +
    "&n=" +
    "&d=" +
    destinationId +
    adultsString +
    childString +
    childAgeString;

  if (window.hotelDataModel.sort) {
    url += "&sort=" + window.hotelDataModel.sort;
  }

  if (
    window.hotelDataModel.filter != null &&
    Object.keys(window.hotelDataModel.filter).length
  ) {
    for (i in window.hotelDataModel.filter) {
      url += `&${i}=${window.hotelDataModel.filter[i]}`;
    }
  }

  var localStorageKey = `${window.prefixSearchHistory}-${$(".js-search-holder-landing").attr("id") ||
    $(this).closest(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
    }`;
  window.updateLocalStorage(localStorageKey, {
    value: { ...window.hotelDataModel },
    baseUrl: url,
    expire: window.hotelDataModel.hotelStartDateEn,
  });

  window.location.assign(url);
});

// hotel booking

//static data
window.adultCountArray = [
  "1 بزرگسال",
  "2 بزرگسال",
  "3 بزرگسال",
  "4 بزرگسال",
  "5 بزرگسال",
  "6 بزرگسال",
];
window.childCountArray = ["0 کودک", "1 کودک", "2 کودک", "3 کودک", "4 کودک"];
window.childAgesArray = [
  "0 - 1",
  "1 - 2",
  "2 - 3 ",
  "3 - 4 ",
  "4 - 5 ",
  "5 - 6 ",
  "6 - 7 ",
  "7 - 8 ",
  "8 - 9 ",
  "9 - 10 ",
  "10 - 11 ",
  "11 - 12 ",
];

const getDate = (dateType, localeType = "fa") => {
  if (!window.searchInitialize?.search) return "";

  let locale = localeType;
  let format = "jYYYY/jMM/jDD";

  if (locale === "en-us") {
    format = "YYYY-MM-DD";
  }

  if (window.searchInitialize?.search) {
    if (dateType === "checkIn") {
      if (window.searchInitialize?.search?.checkIn == null) return "";
      return moment
        .utc(window.searchInitialize?.search?.checkIn)
        .locale(locale)
        .format(format);
    } else if ("checkOut") {
      if (window.searchInitialize?.search?.checkOut == null) return "";

      return moment
        .utc(window.searchInitialize?.search?.checkOut)
        .locale(locale)
        .format(format);
    }
  }
};

window.hotelDataModel = {
  hotelTitle: window.searchInitialize?.search?.destinations?.title,

  cityTitle: "",

  citySlug: window.searchInitialize?.search?.destinations?.citySlug || "",

  slug: window.searchInitialize?.search?.destinations?.slug || "",

  countryTitle: "",

  countrySlug: window.searchInitialize?.search?.destinations?.countrySlug || "",

  id: window.searchInitialize?.search?.destinations?.id || "",

  hotelEndDate: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkOut"),

  hotelEndDateEn: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkOut", "en-us"),

  hotelStartDate: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkIn"),

  hotelStartDateEn: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkIn", "en-us"),

  locationType: window.searchInitialize?.search?.destinations.locationType || 1,

  destinationType:
    window.searchInitialize?.search?.destinations.destinationType,

  daysDuration: null,

  roomsCount: 1,

  childLabels: [],

  dir: "rtl",

  childsCount: 0,

  adultsCount: 0,

  rooms: [
    {
      room: 1,
      adult: 2,
      child: 0,
      childs: [],
    },
  ],

  sort: null,

  filter: null,
};

if (window?.searchInitialize?.search) {
  let newRooms = [];

  window.searchInitialize.search.occupancies.forEach((i) => {
    let newAges = [];

    if (i.ages && i.ages.length) {
      newAges = i.ages.map((age) => age + 1);
    }

    let newRoom = {
      adult: i.adult,
      child: i.childs,
      childs: newAges,
    };

    newRooms.push(newRoom);
  });

  window.hotelDataModel.rooms = newRooms;
  window.hotelDataModel.roomsCount = window.searchInitialize.search.room;
}

var hotelInput = [];

//add or remove room
var roomNum;
$("body").delegate(".js-hotel-form .js-count-box button", "click", function () {
  if ($(this).hasClass("js-max")) {
    if (window.hotelDataModel.roomsCount < 4) {
      roomNum = window.hotelDataModel.roomsCount + 1;

      window.hotelDataModel.roomsCount = roomNum;

      window.hotelDataModel.rooms.push({
        room: roomNum,
        adult: 1,
        child: 0,
        childs: [],
      });
    }
  } else if ($(this).hasClass("js-min")) {
    if (window.hotelDataModel.roomsCount > 1) {
      roomNum = window.hotelDataModel.roomsCount - 1;

      window.hotelDataModel.roomsCount = roomNum;

      window.hotelDataModel.rooms.pop();
    }
  }

  updateTemplate(window.hotelDataModel);
});

// select adult count
$("body").delegate("select.js-rooms-adult-count", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  window.hotelDataModel.rooms[roomIndex].adult = Number($(this).val()) + 1;

  updateTemplate(window.hotelDataModel);
});

//in mobile
$("body").delegate(".js-adults-hotel>button", "click", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  var roomNumber = $(this).hasClass("js-add")
    ? Number($(this).siblings("input").val()) + 1
    : Number($(this).siblings("input").val()) - 1;

  $(this).siblings("input").val(roomNumber);

  window.hotelDataModel.rooms[roomIndex].adult = Number(roomNumber);

  updateTemplate(window.hotelDataModel);
});

//select child count
$("body").delegate("select.js-rooms-child-count", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  window.hotelDataModel.rooms[roomIndex].child = Number($(this).val());

  var oldChildCount = window.hotelDataModel.rooms[roomIndex].childs.length;

  var selectedChildCount = Number($(this).val());

  if (selectedChildCount === oldChildCount) return;

  var newChildCount = 0;

  if (selectedChildCount > oldChildCount) {
    newChildCount = selectedChildCount - oldChildCount;
    for (let i = 0; i < newChildCount; i++) {
      window.hotelDataModel.rooms[roomIndex].childs.push(0);
    }
  } else {
    newChildCount = oldChildCount - selectedChildCount;
    for (i = 0; i < newChildCount; i++) {
      window.hotelDataModel.rooms[roomIndex].childs.pop();
    }
  }

  updateTemplate(window.hotelDataModel);
});

////select child count In mobile
$("body").delegate(
  ".js-hotel-childs-count-InMobile>button",
  "click",
  function () {
    var roomIndex = $(this).closest("ul").attr("data-row");

    var selectedChildCount = $(this).hasClass("js-add")
      ? Number($(this).siblings("input").val()) + 1
      : Number($(this).siblings("input").val()) - 1;

    if (selectedChildCount > 4 || selectedChildCount < 0) return;

    $(this).siblings("input").val(selectedChildCount);

    window.hotelDataModel.rooms[roomIndex].child = selectedChildCount;

    var oldChildCount = window.hotelDataModel.rooms[roomIndex].childs.length;

    // var selectedChildCount = Number($(this).val());

    if (selectedChildCount === oldChildCount) return;

    var newChildCount = 0;

    if (selectedChildCount > oldChildCount) {
      newChildCount = selectedChildCount - oldChildCount;
      for (var i = 0; i < newChildCount; i++) {
        window.hotelDataModel.rooms[roomIndex].childs.push(0);
      }
    } else {
      newChildCount = oldChildCount - selectedChildCount;
      for (var i = 0; i < newChildCount; i++) {
        window.hotelDataModel.rooms[roomIndex].childs.pop();
      }
    }
    updateTemplate(window.hotelDataModel);
  }
);

//select childs Age
$("body").delegate("select.js-child-age", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  var childAgeIndex = Number($(this).attr("name"));
  var childAge = Number($(this).val()) + 1;
  window.hotelDataModel.rooms[roomIndex].childs[childAgeIndex] = childAge;

  updateTemplate(window.hotelDataModel);
});

////////////////////////////
$("body").delegate(".js-room-remove", "click", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  window.hotelDataModel.rooms.splice(Number(roomIndex), 1);
  window.hotelDataModel.roomsCount = window.hotelDataModel.roomsCount - 1;
  updateTemplate();
});

//update Data
function updateDates(e) {
  const checkInDate = e.hasClass("js-hotel-check-in-date")
    ? e
    : e.closest(".hotel-booking__date").find(".js-hotel-check-in-date");
  const checkOutDate = e.hasClass("js-hotel-check-out-date")
    ? e
    : e.closest(".hotel-booking__date").find(".js-hotel-check-out-date");

  window.hotelDataModel.hotelStartDateEn = $(checkInDate).next().val();

  window.hotelDataModel.hotelEndDateEn = $(checkOutDate).next().val();

  window.hotelDataModel.hotelStartDate = $(checkInDate).val();

  window.hotelDataModel.hotelEndDate = $(checkOutDate).val();

  if (
    window.hotelDataModel.hotelStartDate &&
    window.hotelDataModel.hotelStartDateEn === ""
  ) {
    const georgianFormat = "YYYY-MM-DD";
    const jalaaliFormat = "jYYYY/jMM/jDD";
    window.hotelDataModel.hotelStartDateEn = moment
      .utc(window.hotelDataModel.hotelStartDate, jalaaliFormat)
      .locale("en")
      .format(georgianFormat);
  }

  if (window.searchInitialize) {
    updateSummeryBoxInHotelDetail();
  }
}

//change date picker mode
const changeDatePickerMode = (mode) => {
  datePickerMode = mode;
};

const updateCalendarType = () => {
  if ($(".js-hotel-check-in-date").attr("data-lang").length) {
    changeDatePickerMode(2);
  } else {
    changeDatePickerMode(1);
  }
};

const updateSummeryBoxInHotelDetail = () => {
  let summeryCheckInDate = null;
  let summeryCheckOutDate = null;

  if ($(".js-hotel-check-in-date").attr("data-lang").length) {
    summeryCheckInDate = window.hotelDataModel.hotelStartDate;
    summeryCheckOutDate = window.hotelDataModel.hotelEndDate
      ? "-" + window.hotelDataModel.hotelEndDate
      : null;
  } else {
    summeryCheckInDate = window.hotelDataModel.hotelStartDateEn;
    summeryCheckOutDate = window.hotelDataModel.hotelEndDateEn
      ? "-" + window.hotelDataModel.hotelEndDateEn
      : null;
  }
  $("#js-show-check-in").html(summeryCheckInDate);
  $("#js-show-check-out").html(summeryCheckOutDate);
};

//update Template
function updateTemplate() {
  //get adultCount
  window.hotelDataModel.adultsCount = 0;
  window.hotelDataModel.childsCount = 0;

  $.each(window.hotelDataModel.rooms, function (key, room) {
    window.hotelDataModel.adultsCount += room.adult;
    window.hotelDataModel.childsCount += room.child;
  });

  //check if rooms menu is open after update open it
  var flag = false;
  if ($(".js-rooms-toggle").hasClass("hotel-booking__rooms-options--open")) {
    flag = true;
  }
  var labelsArray = countLabelNumbers(window.hotelDataModel.rooms);
  window.hotelDataModel.childLabels = labelsArray;

  $(".js-search-holder-hotel .bounce-loading").remove();

  $(".js-hotel-booking").html(
    $("#js-hotel-template").tmpl(window.hotelDataModel)
  );

  $(".js-internal-hotel-booking").html(
    $("#js-hotel-template").tmpl(window.hotelDataModel)
  );

  if (flag) {
    $(".js-rooms-toggle").addClass("hotel-booking__rooms-options--open");
  }
  checkAlignBox();
  hotelSearch();
  hotelDatePicker();
}

$(".js-go-to-search").click(() => {
  if (window.innerWidth < 993) {
    window.scrollTo(0, 0);

    if (!$(".search-box__form").hasClass("flex-show")) {
      $(".search-box__form").addClass("flex-show");
    }
  }

  $(".js-hotel-check-in-date").datepicker("show");
});

//check align of rooms details menu
function checkAlignBox() {
  if (
    $(".js-hotel-form").offset().left > $(".js-options-rooms").offset().left &&
    $(".rooms-toggleBtn").hasClass("hotel-booking__rooms-options--open")
  ) {
    $(".js-rooms-options").addClass("align-left");
  } else {
    $(".js-rooms-options").removeClass("align-left");
  }
}

function countLabelNumbers(rooms) {
  var childsLabel = ["بزرگسال", "کودک"];
  var max = 0;
  for (var i = 0; i < rooms.length; i++) {
    if (rooms[i].childs.length > max) {
      max = rooms[i].childs.length;
    }
  }
  for (var j = 0; j < max; j++) {
    childsLabel.push("سن کودک  " + (j + 1));
  }
  return childsLabel;
}

//check diff
function calcDiffDate() {
  if (
    !window.hotelDataModel.hotelStartDateEn ||
    !window.hotelDataModel.hotelEndDateEn
  ) {
    return "";
  }
  var startDate = window.hotelDataModel.hotelStartDateEn;
  var endDate = window.hotelDataModel.hotelEndDateEn;

  const date1 = new Date(startDate);
  const date2 = new Date(endDate);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : "-";
}

const hotelDatePicker = () => {
  let datePickerLanguageType = datePickerMode === 2 ? "fa" : "";

  // If it is injected in the hotel min data settings, we will calc it with today and use it
  let minDate = RootDataModel.hotelMinDate
    ? moment(RootDataModel.hotelMinDate).diff(moment(new Date()), "days")
    : -0;

  $(".js-hotel-form .js-hotel-booking-date").pickDate({
    dateFormat: "yy/mm/dd",
    changeMonthAllow: false,
    changeYearAllow: false,
    showButtonPanel: true,
    isDependenceDates: false,
    showCurrentAtPos: 0,
    numberOfMonths: $(window).width() > 991 ? 2 : 1,
    minDate: minDate,
    customClass: "lightTheme",
    showAllMonthsinList: false,
    langType: datePickerLanguageType,
    blurInmobile: true,
    dayNamesShortFa: [
      "1شنبه",
      "2شنبه",
      "3شنبه",
      "4شنبه",
      "5شنبه",
      "جمعه",
      "شنبه",
    ],
    enterDateTitle: "تاریخ ورود",
    exitDateTitle: "تاریخ خروج",
    enterDateTitleEn: "Check in",
    exitDateTitleEn: "Check out",
    dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
    onSelectEvent: function () {
      if ($(this).hasClass("pickDate_2")) {
        var daysDurationParam = calcDiffDate();
        window.hotelDataModel.daysDuration = daysDurationParam;
        if (window.hotelDataModel.daysDuration) {
          $(this)
            .closest(".js-hotel-booking-date")
            .find(".js-hotel-booking-night-count")
            .html(
              "<i class='icon-moon'></i>" + window.hotelDataModel.daysDuration
            )
            .addClass("night-count-show");
        }
      } else {
        window.hotelDataModel.daysDuration = null;
        $(this)
          .closest(".js-hotel-booking-date")
          .find(".js-hotel-booking-night-count")
          .removeClass("night-count-show");
      }
      updateCalendarType();
      updateDates($(this));
    },

    fillHidden: {
      enable: true,
      outPut: "en", //en | Dependent_On_SelectedDate | fa
      customformatInhidden: "YYYY-MM-DD",
      PickDate_Hidden_val: null,
      PickDate2_Hidden_val: null,
    },
  });
};

updateTemplate();

$("body").on("click", function (e) {
  if (!$(e.target).closest(".js-rooms-options").length) {
    if ($(".js-rooms-toggle").hasClass("hotel-booking__rooms-options--open")) {
      $(".js-rooms-toggle").removeClass("hotel-booking__rooms-options--open");
    }
  }
});
